import { render, staticRenderFns } from "./CustomsValueHelp.vue?vue&type=template&id=1a66d5b7"
import script from "./CustomsValueHelp.vue?vue&type=script&lang=js"
export * from "./CustomsValueHelp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports